import About from "./About";
import "./App.css";
import Blog from "./Blog";

import Contact from "./Contact";
import Footer from "./Footer";
// import Home from "./Home";
import Project from "./Project";
import Service from "./Service";
import Home from './Components/Home';
import Skills from "./Skills/Skills";
import FoodDelivery from './Components/ProjectDetails/FoodDelivery/FoodDelivery';
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";
import Medicare from "./Components/ProjectDetails/Medicare/Medicare";
import Header from "./Components/Header/Header";
function App() {
  return (
    <div className="App">
     
       <BrowserRouter>
          <Switch>
          <Route exact path="/">
              <Home />
           </Route>
           <Route path="/home">
              <Home />
           </Route>
            <Route path="/foodshop">
                <FoodDelivery></FoodDelivery>
            </Route>
           
          </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
